import isBrowserContext from 'helpers/isBrowserContext';
import React, { useEffect } from 'react'

import { AppLoadingState } from './useAppLoading';

export default function useRekomCookieFormVisibilityController(viewState:AppLoadingState) {
    // Toggle Cookie Modal visibility.
    // ------------------------------
    // will show the rekom cookie banner (rekom-form-manager) when the viewState changes to LOADED
    // it uses an interval to look in the dom for the element, but if the element is not found
    // after the view state is loaded it will clean it self up.
    // 
    // dependencies: 
    // A global style i index.scss:
    //
    // rekom-form-manager { visibility: hidden; }
    // 
    const TERMINATE_DELAY = 5000;
    const REVEAL_FORM_DELAY = 2500;
    useEffect(() => {
        // keep watching for the element
        let terminateTimeoutId: any = 0;
        const intervalId = setInterval(() => {

            const isBrowser = isBrowserContext()

            const el = isBrowser ? window.document.querySelector('rekom-form-manager') as HTMLDivElement : null
            // terminate the interval it not found.
            if (viewState == AppLoadingState.LOADED && el === null) {
                terminateTimeoutId = setTimeout(() => {
                    clearInterval(intervalId);
                }, TERMINATE_DELAY);
            }
            if (el) {
                if (viewState == AppLoadingState.LOADED) {
                    setTimeout(() => {
                        el.style.visibility = 'visible'
                    }, REVEAL_FORM_DELAY)
                }
                clearInterval(intervalId)
                clearTimeout(terminateTimeoutId);
            }
        }, 50)
        return () => {
            clearInterval(intervalId)
            clearTimeout(terminateTimeoutId);
        }
    }, [viewState])
}